import { render } from "./PatternEditor.vue?vue&type=template&id=f2d0b530&scoped=true"
import script from "./PatternEditor.vue?vue&type=script&lang=js"
export * from "./PatternEditor.vue?vue&type=script&lang=js"

import "./PatternEditor.vue?vue&type=style&index=0&id=f2d0b530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d0b530"]])

export default __exports__